// Klaviyo's own click-interception on "My Account" (href="#k-hub") is unreliable
// on PLP/mobile - sometimes the drawer opens hidden behind another popup,
// sometimes the click isn't intercepted at all and falls through to a real nav.
// The floating hub-launcher widget (bottom-right corner icon) reliably opens the
// same Customer Hub modal, so redirect "My Account" clicks to that button instead.
// Runs in the capture phase so it wins even if Klaviyo's own listener also fires
// or the browser would otherwise follow the link's href.
(function () {
  // Match by our own data-account-link attribute (or link text as fallback),
  // not href="#k-hub" - Klaviyo can rewrite the href again at click-time
  // (observed swapping it to "/account/logout"), so matching the href
  // attribute misses that case. Our own markup stays stable.
  function isAccountLink(el) {
    var a = el.closest('a');
    if (!a) return false;
    if (a.hasAttribute('data-account-link')) return true;
    return a.textContent.trim().toLowerCase() === 'my account';
  }

  document.addEventListener('click', function (e) {
    if (!isAccountLink(e.target)) return;

    var launcher = document.querySelector('.kl-hub-launcher');
    if (!launcher) return; // widget not loaded yet - let default behavior happen

    e.preventDefault();
    e.stopPropagation();
    launcher.click();
  }, true);
})();
